import axios from "axios";

export const baseURL = 'https://iyab.io/api';
//export const baseURL = 'http://localhost:30000';
 //export const baseURL = 'https://iyabbackend.thesmartlogic.com';

const createAPI = () => {

  const instance = axios.create({
    baseURL: baseURL,
  });

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.error("Error Response:", error.response);

      // Check for unauthorized access or missing token
      if (error.response && (error.response.status === 401)) {
        console.log(error?.response.status)
        window.location.href = '/dashboard/login';
      }

      return Promise.reject(error);
    }
  );

  return instance;
};


const apiInstance = createAPI();

export const API = apiInstance;
export const login = "/auth/login";
export const googleLogin = "/auth/google";
export const signup = "/auth/signup";
export const verify = "/auth/SendVerificationCode";
export const verifyCode = "/auth/CodeVerification";
// export const getCourses = "/Course/getCourses";
export const enrolledSpecificLearningJourney = "/LearningJourney/enrolledSpecificLearningJourney";
export const getLookups = "/Lookups/getLookupsByType/Intrestes";

export const getRecommanedTobics = "/Lookups/getRecommanedTobics";
export const API_EndPointAddStudentInfo = "/Student/addStudentInfo";

export const API_EndPointACC = "/LearningJourney/enrolledStudentAnswers";
export const API_EndPointEB = "/LearningJourney/enrolledStudentAnswers";
export const API_EndPointEnrolledJ = "/LearningJourney/allLearningJourneysEnrolled";
export const API_EndPointEnrolledJdata = "/LearningJourney/getLearningJourneyData";
export const API_setSeeTour = "/LearningJourney/setSeeTour";
export const API_EndPointActivityData = "/LearningJourney/getModuleActivitesData";
export const API_EndPointSubmitAnswer = "/LearningJourney/submitActivityAnswer";
export const addNewSuggestedLearningJourney = "/LearningJourney/addNewSuggestedLearningJourney";
export const API_AddAssessmentTest = "/LearningJourney/addAssessmentTest";
export const API_GetModuleData = "/Module/getModule";
export const API_ReadyMadelearningJourneys = "/ReadyMadeJourney/getReadyMadelearningJourneys";
export const API_ReadyMadeJourneyData = "/ReadyMadeJourney/getReadyMadeJourneyData";
export const API_GetModule = "/ReadyMadeJourney/getModule";
export const API_AddContactMessage = "/Contact/addContactMessage";
export const API_GetViewedModulesData = "/Module/getAllViewedModules";
export const API_GetStudentUserData = "/Student/getStudentUserData";
export const API_UpdateStudentInfo = "/Student/updateStudentInfo";
export const API_ChangePassword = "/Student/updatePassword";
export const API_GetAllDoneModulesByUserId = "/LearningJourney/getAllDoneModulesByUserId";
export const API_GetAllProgressModulesByUserId = "/LearningJourney/getAllProgressModulesByUserId";
export const API_CancelLearningJourney = "/LearningJourney/cancelLearningJourney";
export const API_addCommunityMessage = "/Community/addCommunityMessage";
export const API_AllCommunityMessages = "/Community/allCommunityMessages";
export const API_AllCommunityAnnouncement = "/Community/allCommunityAnnouncement";

export const getApiUrl = (endpoint: string): string => {
  return `${baseURL}${endpoint}`;
};


